module.exports = __webpack_public_path__ + "static/media/linkCallIcon.b169a0eb.svg";